import React from 'react';
import { Box, Typography, LinearProgress, Paper } from "@mui/material";

function LatestInformation({ summaryData }) {
    const summaryContainerSx = {
        width: '100%',
        maxWidth: 720,
        mx: 'auto',
        px: { xs: 2, md: 3 },
        py: 2.5,
        boxSizing: 'border-box',
    };

    const distributionListSx = {
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
        maxWidth: 640,
        mx: 'auto',
    };

    const betItemHeaderSx = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        mb: 0.5,
    };

    const progressSx = {
        height: 8,
        borderRadius: 4,
    };

    const hasSummaryData = Boolean(summaryData && summaryData.betBySelection);

    const renderSummary = () => {
        if (!hasSummaryData) {
            return <Typography>ベット情報はまだありません。</Typography>;
        }

        const { totalBet, betBySelection, answers } = summaryData;

        return (
            <Box sx={{ width: '100%' }}>
                <Typography variant="h6" gutterBottom>現在の状況</Typography>
                <Typography variant="body1">総ベット額: {totalBet} pt</Typography>

                <hr style={{ margin: '16px 0' }} />

                <Typography variant="h6" gutterBottom>選択肢ごとのベット分布</Typography>
                {betBySelection.length > 0 ? (
                    <Box sx={distributionListSx}>
                        {betBySelection.map((bet, idx) => {
                            const percentage = totalBet > 0 ? (bet.totalBet / totalBet) * 100 : 0;
                            return (
                                <Box key={idx}>
                                    <Box sx={betItemHeaderSx}>
                                        <Typography variant="body1">
                                            {answers[bet.selection] || `選択肢 ${bet.selection}`}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {bet.totalBet} pt ({percentage.toFixed(1)}%)
                                        </Typography>
                                    </Box>
                                    <LinearProgress variant="determinate" value={percentage} sx={progressSx} />
                                </Box>
                            );
                        })}
                    </Box>
                ) : (
                    <Typography>ベットデータがありません</Typography>
                )}
            </Box>
        );
    };

    if (!hasSummaryData) {
        return (
            <Box sx={summaryContainerSx}>
                {renderSummary()}
            </Box>
        );
    }

    return (
        <Paper elevation={3} sx={summaryContainerSx}>
            {renderSummary()}
        </Paper>
    );
}

export default LatestInformation;
